import { AppContextState } from "src/AppContextProvider";

/**
 * Check if user can access billing routes (for RouteController)
 * Only checks permissions and draft status, customer check is handled in components
 */
export const canAccessBillingRoutes = (context: AppContextState): boolean => {
  return !!(
    context.currentPermissions.validateAnySpace("billing", "manage") &&
    !context.currentOrg?.isDraft
  );
};
